// Angular
import { BreakpointObserver } from '@angular/cdk/layout';
import { computed, inject, Injectable, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

// App types
import { ScreenSize } from '@app/core/types/screen-size.type';


@Injectable()
export class LayoutService {
  private breakpointObserver = inject(BreakpointObserver);

  private readonly sizeWeights: Record<ScreenSize, number> = {
    '2xs': 0, 'xs': 1, 'sm': 2, 'md': 3, 'lg': 4, 'xl': 5, '2xl': 6
  };

  readonly size = signal<ScreenSize>('xl');

  private readonly config = {
    '2xs': '(max-width: 479.98px)',                         // زیر 480
    'xs':  '(min-width: 480px) and (max-width: 639.98px)',  // 480 تا 640
    'sm':  '(min-width: 640px) and (max-width: 767.98px)',  // 640 تا 768
    'md':  '(min-width: 768px) and (max-width: 1023.98px)', // 768 تا 1024
    'lg':  '(min-width: 1024px) and (max-width: 1279.98px)',// 1024 تا 1280
    'xl':  '(min-width: 1280px) and (max-width: 1535.98px)',// 1280 تا 1536
    '2xl': '(min-width: 1536px)',                           // بالای 1536
  };

  constructor() {
    this.breakpointObserver
      .observe(Object.values(this.config))
      .pipe(takeUntilDestroyed())
      .subscribe((result) => {
        for (const [key, query] of Object.entries(this.config)) {
          if (result.breakpoints[query]) {
            this.size.set(key as ScreenSize);
            break;
          }
        }
      });
  }

  isMobile = computed(() => this.sizeWeights[this.size()] <= this.sizeWeights['sm']);
  isTablet = computed(() => this.size() === 'md' || this.size() === 'lg');
  isDesktop = computed(() => this.sizeWeights[this.size()] >= this.sizeWeights['xl']);


  isAtLeast(s: ScreenSize) {
    return computed(() => this.sizeWeights[this.size()] >= this.sizeWeights[s]);
  }

  isAtMost(s: ScreenSize) {
    return computed(() => this.sizeWeights[this.size()] <= this.sizeWeights[s]);
  }
}
